<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="create-toplist" animation="fadeInRight">
      <div slot="title">Create New Toplist</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Toplist Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addToplist['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Website</div>
            <div class="col-lg-9">
              <input type="url" name="" class="form-control" v-model="addToplist['website']">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-sm btn-primary" @click="saveToplist">Save</button>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Toplists</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#create-toplist">Create new Toplist</button>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import List from './Toplists/List'
import axios from 'axios'
import { TOPLISTS_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'

const toplistAddDefaults = {
  name: '',
  website: ''
}

export default {
  data () {
    return {
      addToplist: {...toplistAddDefaults}
    }
  },
  mounted () {
    document.title = 'Toplists Overview :: PBN360 by Aphex Media'
  },
  components: {
    list: List,
    modalForm: Modal
  },
  methods: {
    saveToplist () {
      const addToplist = {...this.addToplist}
      if (!addToplist.name || !this.isValidURL(addToplist.website)) {
        this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
        return
      }
      axios.post('/advertisers/toplists', addToplist)
        .then(r => {
          $('#create-toplist').modal('hide')
          this.$store.commit(TOPLISTS_SET, [...this.$store.state.toplists, r.data])
          this.$toastr.success('Affiliate Company added successfully', 'Brilliant stuff lad')
        })
        .catch(e => {
          const msg = e.response ? e.response.data.msg : 'Not so great is it...'
          this.$toastr.error(e, msg)
        })
      // Reset form to defaults
      Object.keys(toplistAddDefaults).forEach(k => {
        this.$set(this.addToplist, k, toplistAddDefaults[k])
      })
    },
    isValidURL (string) {
      const regex = /^(https?:\/\/)?(([\da-z.-]+)\.([a-z.]{2,6})|([\d.]+))([/\w .-]*)*\/?$/
      return regex.test(string)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Toplists.vue